/*
  ff-quiz-tracking.js — GA4 funnel events for the Octane AI hair quiz.

  Loaded only on pages that embed an Octane quiz (see layout/theme.liquid).
  Listens to the lifecycle events Octane fires on `document` and forwards a
  lean, PII-free funnel to GA4 through window.ffTrack (assets/ff-analytics.js).

  Funnel:  quiz_view → quiz_start → quiz_question_answered (n) → quiz_complete
           → quiz_product_click / quiz_add_to_cart / quiz_checkout_click
           → (standard) add_to_cart → begin_checkout → purchase

  Octane docs: https://help.octaneai.com/en/articles/6092557-how-octane-ai-developer-tools-work
*/
(function () {
  var embed = document.querySelector('.octane-ai-quiz');
  if (!embed || typeof window.ffTrack !== 'function') return;

  var clip = window.ffTrack.clip;
  var quizId = embed.getAttribute('data-quiz-id') || undefined;
  var started = false;
  var completed = false;
  var questionIndex = 0;

  function base(extra) {
    var params = { quiz_id: quizId };
    for (var key in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, key)) params[key] = extra[key];
    }
    return params;
  }

  function detailOf(event) {
    return (event && event.detail) || {};
  }

  // Answer values are only forwarded for multiple-choice questions. Email,
  // phone and free-text answers are personal data and never leave the page.
  function safeAnswer(detail) {
    if (detail.question_type !== 'multiple_choice') return undefined;
    var value = detail.question_value;
    if (Array.isArray(value)) value = value.join(', ');
    return clip(value, 100);
  }

  function productSummary(detail) {
    var products = [];
    (detail.sections || []).forEach(function (section) {
      (section.products || []).forEach(function (product) {
        if (product && product.title) products.push(product.title);
      });
    });
    return {
      result_product_count: products.length,
      result_products: clip(products.slice(0, 5).join(' | '), 100)
    };
  }

  window.ffTrack('quiz_view', base());

  document.addEventListener('octane.quiz.questionAnswered', function (event) {
    var detail = detailOf(event);

    // The first page advanced is the start, whatever its type: on this quiz
    // that is the "Get started" explainer.
    if (!started) {
      started = true;
      window.ffTrack('quiz_start', base({
        start_page_type: detail.question_type,
        question_title: clip(detail.question_title, 100)
      }));
    }

    // Explainer screens are not questions; keep question_index aligned with
    // the "Question n of m" counter Octane shows.
    if (detail.question_type === 'explainer') return;
    questionIndex += 1;

    window.ffTrack('quiz_question_answered', base({
      question_index: questionIndex,
      question_id: clip(detail.question_id, 60),
      question_title: clip(detail.question_title, 100),
      question_type: detail.question_type,
      answer: safeAnswer(detail),
      next_question_type: detail.new_question_type
    }));

    if (detail.question_type === 'email' && detail.question_value) {
      window.ffTrack('quiz_email_capture', base({
        marketing_consent: detail.question_consent_value === true ? 'yes' : detail.question_consent_value === false ? 'no' : 'not_asked'
      }));
    }
  });

  document.addEventListener('octane.quiz.completed', function (event) {
    if (completed) return;
    completed = true;
    var detail = detailOf(event);
    var summary = productSummary(detail);
    window.ffTrack('quiz_complete', base({
      questions_answered: questionIndex,
      has_email: detail.email ? 'yes' : 'no',
      result_product_count: summary.result_product_count,
      result_products: summary.result_products
    }));
  });

  // Results page opened from a shared link rather than by finishing the quiz.
  document.addEventListener('octane.quiz.accessed', function () {
    window.ffTrack('quiz_results_accessed', base());
  });

  function productParams(detail) {
    var product = detail.product || detail;
    return {
      item_name: clip(product.title || product.name, 100),
      item_id: clip(product.id || product.product_id || product.variant_id, 60)
    };
  }

  document.addEventListener('octane.quiz.goToProductPage', function (event) {
    window.ffTrack('quiz_product_click', base(productParams(detailOf(event))));
  });

  document.addEventListener('octane.quiz.addToCart', function (event) {
    window.ffTrack('quiz_add_to_cart', base(productParams(detailOf(event))));
  });

  document.addEventListener('octane.quiz.addToCartError', function () {
    window.ffTrack('quiz_add_to_cart_error', base());
  });

  document.addEventListener('octane.quiz.viewCart', function () {
    window.ffTrack('quiz_view_cart', base());
  });

  document.addEventListener('octane.quiz.goToCheckout', function () {
    window.ffTrack('quiz_checkout_click', base());
  });
})();
